import React, { useState } from "react";
import { Tree, Divider, Space, Button, message, Form, Col, Row, Select, Tooltip, Popconfirm, Spin, Table, Modal, Input, Cascader } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { EyeSlashIcon, EyeIcon } from "../../admin/Icons";
import { apiCall } from "../../utils/Api"
import { ucfirst } from "../../utils/Utils";

export default function TrashedContent(props) {

    const {menus= [], content = [], updateContent = () => {}, page = ""} = props; 

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [trashed, setTrashed] = useState([]);
    const [selected, setSelected] = useState(false);
    const [form] = Form.useForm();


    const close = () =>{
        setVisible(false);
        setSelected(false);
    }


    const recoverContent = (_f) => {

        let c = [...content];
        let _s = {...selected}
        _s.name = _f.name; 
        _s.visibility = _f.visibility; 
        c.push(selected);
        updateContent(c)
        close(); 
        message.success("Content recovered successfully.")
        
    }

    const getTrashed = () => {
        setLoading(true)
        apiCall("site_content/getTrashedContent", {}, (_status, _result) => {
            if (_status) {
                setTrashed(_result);
                setVisible(true);
                setLoading(false)
            }
        });
    }

    const deleteContent = (_content) => {
        apiCall("site_content/deleteContent", { content_id: _content.id }, (_status, _result) => {
            if (_status) {
                message.success("Content deleted successfully.");
                setTrashed(_result);
                setSelected(false)
            } else {
                message.error(_result.error);
            }
        })
    }

    const deslug = (_str) => {
        return _str.split("_").map(item => {
            return ucfirst(item);
        }).join(" ")
    }

    const convertMenus = (_arr) => {

        let m = [...menus]

        let _ret = m.filter(item => !item.parent_id).map(item => {
            return {
                value: item.id,
                label: item.name,
                children: m.filter(i => i.parent_id === item.id).map(child => {
                    return {
                        value: child.id,
                        label: child.name,
                    }
                })
            }
        })

        _ret.unshift({
            value: "global",
            label: "Global Banner",
            children: []
        })

        return _ret;

    }

    const options = convertMenus();


    const selectContent = (_item = selected) => {
        setSelected(_item);
        form.setFieldsValue({ "name": _item.name });
        form.setFieldsValue({ "visibility": _item.visibility });
    }


    const columns = [
        { title: <small>Name</small>, dataIndex: "name", key: "name" },
        {
            title: <small>Type</small>, dataIndex: "component", key: "component", render: (e) => {
                return deslug(e)
            }
        },
        {
            title: <small>Actions</small>, width: 115, dataIndex: "actions", key: "actions", render: (e, f) => {
                return (
                    <Space>
                        <Popconfirm onConfirm={() => deleteContent(f)} okText="Delete" okType="danger" title="Are you sure?"><Button size="small" danger type="primary" ><small>Delete</small></Button></Popconfirm>
                        <Button onClick={() => selectContent(f)} type="primary" size="small"><small>Select</small></Button>
                    </Space>
                )
            }
        },
    ]

    const rowClassName = (record) => {
        return record.id === selected?.id ? 'ant-table-row-selected' : '';
    };

    const drawForm = () => {
        return (
            <>
                <strong>Recover trashed content</strong>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Table rowKey={"id"} rowClassName={rowClassName} pagination={false} style={{ "border": "1px solid #eee" }} scroll={{ y: 201 }} size="small" columns={columns} dataSource={trashed} />
                <Divider />

                <Form onFinish={(_f) => recoverContent(_f)} form={form} layout="vertical">
                    <Spin indicator={<></>} spinning={!selected}>
                        <Row gutter={30}>
                            <Col span={16}>
                                <Form.Item initialValue={selected.name} name="name" rules={[{ required: true, message: "Name required" }]} label="Name">
                                    <Input placeholder="Name..." />
                                </Form.Item>

                                <Form.Item label="Page">
                                    <Input disabled value={page} />
                                </Form.Item>

                                {/* <Form.Item initialValue={0} name="parent_id" label="Parent">
                                    <Cascader changeOnSelect style={{ "width": "100%" }} options={options} placeholder="Select page..." />
                                </Form.Item> */}
                            </Col>

                            <Col span={8}>
                                <Form.Item name="visibility" label={<Tooltip title={<>
                                    <nobr><strong>Draft:</strong> -  Inaccessible </nobr><br />
                                    <nobr><strong>Visible:</strong> - Accessed on menu / URL</nobr><br />
                                    <nobr><strong>Unlisted:</strong> - Accessed solely via URL</nobr><br />
                                </>}><div style={{ "cursor": "pointer" }}>Visibility? <QuestionCircleOutlined style={{ "color": "#aaa", "fontSize": "11px" }} /></div></Tooltip>}>
                                    <Select style={{ "width": "100%" }}>
                                        <Select.Option value="test"><div style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div></Select.Option>
                                        <Select.Option value="visible"><div style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div></Select.Option>
                                        <Select.Option value="hidden"><div style={{ "color": "#aa119d", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#aa119d" }} />&nbsp; Unlisted</div></Select.Option>
                                    </Select>
                                </Form.Item>

                            </Col>
                        </Row>
                    </Spin>


                    <Divider style={{ "margin": "0px 0px" }} />
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                    <div className="float-flex">
                        <Button>Cancel</Button>
                        <Space>
                            <Popconfirm onConfirm={() => deleteContent(selected)} okText="Delete" okType="danger" title="Are you sure?"><Button disabled={!selected} danger type="primary" >Delete</Button></Popconfirm>
                            <Button disabled={!selected} htmlType="submit" type="primary">Recover</Button>
                        </Space>
                    </div>
                </Form>
            </>
        )
    }

    return (
        <>
            <Modal footer={null} onCancel={() => setVisible(false)} open={visible}>
                {drawForm()}
            </Modal>
            <Divider style={{ "margin": "15px 0px" }} />
            <Button loading={loading} type="primary" block onClick={() => getTrashed()} size="small"><small>Recover Trashed Content</small></Button>
        </>
    )
}